import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Styled from "./styles";
import { useLogout } from "../../services/mutations";
import { isUserLoggedIn } from "../../utils/helpers";
import { ASSETS } from "../../utils/config";
import UserImage from "../UserImage";
import { logout } from "../../redux/actions";
import { TextView } from "@components";
import ReferralsIcon from "assets/images/referrals-icon.svg";
import grid from "@assets/images/grid.svg";
import log_out from "@assets/images/log_out.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LoginIcon from "@mui/icons-material/Login";
import { useLocation } from "react-router-dom";
import { resetGallery } from "../../redux/reducers/gallery";
import { clearGalleryPopup } from "../../redux/reducers/galleryPopup";
import { getLoggedInUser } from "../../utils/helpers";
import { useQueryClient } from "react-query";
import { getHasUnsavedChanges } from "../../redux/selectors/segmentBuilderSelectors";
import { clearAllAiWheels } from "../../redux/reducers/aiWheels";
import WheelComponent from "../WheelComponent";
import { useIfUserEligible } from "../../hooks/useIfUserEligible";
import { FEATURES } from "../../constants/features";

const ProfileMenu = React.forwardRef(
  (
    {
      setModalOpen = null,
      setOnLeave = null,
      onClickBeta = () => {},
      className,
      isJoyrideOpen = false,
      wheelUpdatedDataSorted = [],
      isModalOpen = false, // New prop
    },
    ref
  ) => {
    const { userProfile } = useSelector((state) => state.userProfile);
    const hasUnsavedChanges = useSelector(getHasUnsavedChanges);
    const [showDropdown, setShowDropdown] = useState(false);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [clicked, setClicked] = useState(false);
    const [isLoggingOut, setisLoggingOut] = useState(false);
    const location = useLocation();

    const userType = userProfile?.referral_type;
    const { isInReferralProgram } = useIfUserEligible(FEATURES.REFFERAL_PROGRAM);
    let nav = useNavigate();
    const dispatch = useDispatch();
    let userLogout = useLogout();
    const dropdownRef = useRef();
    const queryClient = useQueryClient();

    const handleLogout = () => {
      setisLoggingOut(true);
      userLogout.mutate(null, {
        onSuccess: (response) => {
          setisLoggingOut(false);
          dispatch(logout());
          dispatch(resetGallery());
          dispatch(clearGalleryPopup());
          dispatch(clearAllAiWheels());
          localStorage.removeItem("keyCloak");
          sessionStorage.removeItem("referralData");
          queryClient.clear();
          nav("/login");
        },
        onError: (err) => {
          setisLoggingOut(false);
        },
      });
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          // If a click is outside the dropdown
          if (isModalOpen || isJoyrideOpen) {
            // If a modal is open or Joyride step active, do NOT close the dropdown
            return;
          }
          // If click target is one of the Joyride upgrade links, ignore
          const ignoreIds = [
            "premium-link",
            "prosuite-link",
            "upgrading-link",
            "premium-earnings-link",
            "prosuite-earnings-link",
          ];
          if (ignoreIds.includes(event.target.id)) {
            return;
          }
          // Otherwise, close the dropdown
          setShowDropdown(false);
          setClicked(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [dropdownRef, isModalOpen]);

    useEffect(() => {
      if (!showDropdown) {
        setActiveIndex(-1);
      } else if (isJoyrideOpen) {
        setActiveIndex(1);
      }
    }, [showDropdown, isJoyrideOpen]);

    const handleDropdownItemClick = (action) => {
      if (hasUnsavedChanges && setOnLeave && setModalOpen) {
        setOnLeave(() => action);
        setModalOpen(true);
        setShowDropdown(false);
      } else {
        action();
        setShowDropdown(false);
      }
    };

    React.useImperativeHandle(ref, () => ({
      toggleDropdown: () => {
        setClicked(true);
        setShowDropdown(!showDropdown);
      },
      closeDropdown: () => {
        setClicked(false);
        setShowDropdown(false);
      },
    }));

    return (
      <Styled.UserContainer
        clicked={clicked}
        ref={dropdownRef}
        className={className}
        onClick={() => {
          setClicked(true);
          setShowDropdown(!showDropdown);
        }}
      >
        {" "}
        {wheelUpdatedDataSorted && wheelUpdatedDataSorted?.length > 0 ? (
          <WheelComponent
            userData={{
              id: Math.random(),
              url: userProfile?.profile_image || ASSETS.iyugaLogo,
            }}
            maxSelectedArcs={0}
            arcThickness={0}
            chartData={wheelUpdatedDataSorted}
            margin={1}
            setChartData={() => {}}
            containerDivStyle={{
              width: "100%",
              height: "100%",
              maxWidth: "46px",
              maxHeight: "46px",
              marginRight: 10,
            }}
            config={{
              showTooltips: false,
            }}
          />
        ) : (
          <UserImage
            style={{ marginRight: 10 }}
            image={userProfile?.profile_image}
            size={42}
          />
        )}
        {showDropdown ? (
          !isUserLoggedIn() ? (
            <>
              <Styled.Dropdown>
                <Styled.DropdownItem
                  onClick={() => handleDropdownItemClick(() => nav("/login"))}
                >
                  <LoginIcon style={{ fontSize: "15px", marginRight: "5px" }} />
                  Sign in
                </Styled.DropdownItem>
                <Styled.DropdownItem
                  onClick={
                    () => nav("/signup")
                    // handleDropdownItemClick(onClickBeta)
                  }
                >
                  <AccountBoxIcon
                    style={{
                      fontSize: "18px",
                      marginTop: "1px",
                      marginRight: "5px",
                    }}
                  />
                  Sign up for Beta
                </Styled.DropdownItem>
              </Styled.Dropdown>
            </>
          ) : (
            <Styled.Dropdown>
              {location.pathname !== "/gallery" && (
                <Styled.DropdownItem
                  onClick={() =>
                    handleDropdownItemClick(() =>
                      nav(`/gallery/${getLoggedInUser().id}`)
                    )
                  }
                >
                  <Styled.DropdownImage src={grid} alt="Gallery" />{" "}
                  <TextView>Gallery</TextView>
                </Styled.DropdownItem>
              )}
              <Styled.DropdownItem
                onClick={() => handleDropdownItemClick(() => nav("/explore"))}
              >
                <Styled.DropdownImage3
                  style={{ height: "19px", width: "19px" }}
                  src={ASSETS.explore}
                  alt="explore"
                />
                <TextView>Explore</TextView>
              </Styled.DropdownItem>
              <Styled.DropdownItem
                onClick={() => handleDropdownItemClick(() => nav("/settings"))}
              >
                <Styled.DropdownImage src={ASSETS.settings} alt="Settings" />
                <TextView>Settings</TextView>
              </Styled.DropdownItem>
              <Styled.DropdownItem
                className="earnings-portal-dropdown-item"
                isActive={activeIndex === 1}
                onClick={() => handleDropdownItemClick(() => nav("/referrals"))}
              >
                <Styled.DropdownImage2
                  src={ASSETS.Office}
                  alt="earingsportal"
                />{" "}
                <TextView>{isInReferralProgram ? "Earnings Portal" : "Analytics"}</TextView>
              </Styled.DropdownItem>

              <Styled.Divider />
              <Styled.DropdownItem
                onClick={() => handleDropdownItemClick(handleLogout)}
              >
                <Styled.DropdownImage src={log_out} alt="Logout" />{" "}
                <TextView>Logout</TextView>
              </Styled.DropdownItem>
            </Styled.Dropdown>
          )
        ) : null}
      </Styled.UserContainer>
    );
  }
);

export default ProfileMenu;
